import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col, Card, Input, Button, PageHeader } from "antd";
import { AuthAction } from "../../store/actions";
import BlackImage from "../../assets/images/trkrLogo.png";
import LoaderGif from "../../assets/images/ie_loader.gif";
import NavbarContainer from "../../components/navbar";
import UserIcon from "../../assets/images/User.png";
import UserIconOver from "../../assets/images/UserOver.png";
import KeyIcon from "../../assets/images/key.png";
import KeyIconOver from "../../assets/images/keyOver.png";
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
    };
  }

  onHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Error`]: "",
      errorReducer: "",
    });
  };
  onSubmit = () => {
    const { email, password } = this.state;
    const { storeInfo } = this.props;

    if (!email.length || !password.length) {
      if (!email.length) {
        this.setState({
          emailError: "Email required",
        });
      }
      if (!password.length) {
        this.setState({
          passwordError: "Password is required ",
        });
      }
      return;
    }
    this.props.signin(
      { email, password, store_url: storeInfo?.rmx_company_asset?.store_url },
      () => this.props.history.push("/dashboard")
    );
  };
  componentDidUpdate(preProps, PreState) {
    if (preProps.error !== this.props.error && !this.props.loader) {
      this.setState({
        errorReducer: "Oops, thats not a match",
      });
    }
  }

  render() {
    const { signin, loader, error } = this.props;
    const { emailError, passwordError, errorReducer } = this.state;
    return (
      <SignInContainer>
        <Row justify="center" align="middle">
          <Col
            xs={22}
            sm={18}
            md={12}
            lg={10}
            xl={10}
            style={{ marginTop: "7.5rem" }}
          >
            <Row justify="center" gutter={[0, 40]} align="middle">
              <Col span={24} style={{ marginTop: "1" }}>
                <Card style={{ width: "100%" }}>
                  <Row
                    justify="center"
                    gutter={[0, 20]}
                    style={{ position: "relative" }}
                  >
                    <Col
                      style={{
                        height: "160px",
                        borderRadius: "50%",
                        backgroundSize: "cover",
                        backgroundImage: `url(${BlackImage})`,
                        position: "absolute",
                        top: "-80px",
                        width: "160px",
                        backgroundRepeat:'no-repeat'
                      }}
                    ></Col>
                    <Col span={24} style={{ marginTop: "6rem" }}>
                      <Row gutter={[0, 15]} justify="center">
                        <Col span={21}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "10px",
                              fontSize: "1.1rem",
                              letterSpacing: ".5px",
                            }}
                            bordered={false}
                            size="25"
                            placeholder="USERNAME"
                            name="email"
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["email_onHover"]
                                    ? UserIcon
                                    : UserIconOver
                                }
                              />
                            }
                          />
                          <Row>
                            <Col span={24}>
                              <span className="text-right d-grid danger-color">
                                {emailError && emailError}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={21}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "10px",
                              fontSize: "1.1rem",
                              letterSpacing: ".5px",
                            }}
                            bordered={false}
                            size="25"
                            placeholder="PASSWORD"
                            name="password"
                            type="password"
                            onChange={this.onHandleChange}
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            prefix={
                              <img
                                src={
                                  !this.state["password_onHover"]
                                    ? KeyIcon
                                    : KeyIconOver
                                }
                              />
                            }
                          />
                          <Row>
                            <Col span={24}>
                              <span
                                className={`text-right ${
                                  !errorReducer && "d-grid"
                                } danger-color`}
                              >
                                {errorReducer && errorReducer}

                                {passwordError && passwordError}
                              </span>
                            </Col>
                          </Row>{" "}
                        </Col>
                      </Row>
                    </Col>
                    <Col span={20}>
                      <Row justify="end">
                        <Col>
                          <strong
                            className="pointer-cursor plant-forgot-psd navbar-font-family"
                            onClick={() => this.props.history.push("/forgot")}
                          >
                            FORGOT PASSWORD?
                          </strong>
                        </Col>
                      </Row>
                      <Row justify="center">
                        <Col span={24} style={{ marginTop: "20px" }}>
                          <Button
                            style={{
                              backgroundColor: "#ff9800",
                              color: "#fff",
                              width: "50%",
                              letterSpacing: ".5px",
                              transition: ".2s ease-out(red)",
                              fontSize: "12px",
                            }}
                            onClick={this.onSubmit}
                          >
                            LOGIN
                          </Button>
                          {loader && (
                            <img src={LoaderGif} height={"60"} width={"60"} />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={24} className="signinFormFooter">
                <span
                  style={{
                    fontSize:'12px',
                    color:'white'
                  }}
                >
                  if you have don`t have a Username
                  <br />
                  <strong
                    className="pointer-cursor text-center"
                  style={{fontSize:'28px'}}
                    // onClick={() => this.props.history.push("/register")}
                    onClick={() =>
                      window.open(`${process.env.REACT_APP_LINK}://app${process.env.REACT_APP_DOMAIN}/#/rmx/register`)
                    }
                  >
                    Register here.
                  </strong>
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </SignInContainer>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    error: storeState?.AuthReducer.error,
    storeInfo: storeState?.AuthReducer?.storeInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signin: (payload, cb, callback) => {
      dispatch(AuthAction.SignIn(payload, cb));
    },

    socialSignIn: (payload, cb) => {
      dispatch(AuthAction.SocialSignInReq(payload, cb));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
